import { FC } from "react";
import Channel from "../../components/SendBird/Channel";
import CrossIcon from "../../assets/svg-fc/CrossIcon";
import WhatsAppBannerIcon from "../../assets/svg-fc/WhatsAppBannerIcon";
import "./sendBirdChatStyle.scss";

export interface iChatProp {
	chanelUrl: string;
	onSendChat?: () => void;
	showWhatsAppBanner?: boolean;
	isWhatsappGroupCreated?: boolean;
	isCorporateEvent?: boolean;
	handleShowWhatsAppModal?: () => void;
	handleShowWhatsAppBanner: (value: boolean) => void;
	handleSendbirdMessageUpdates?: () => void;
}

const Chat: FC<iChatProp> = ({
	chanelUrl,
	onSendChat,
	showWhatsAppBanner,
	handleShowWhatsAppModal,
	handleShowWhatsAppBanner,
	isWhatsappGroupCreated,
	isCorporateEvent = false,
	handleSendbirdMessageUpdates,
}) => {
	const showingWhatsAppBanner = showWhatsAppBanner && isWhatsappGroupCreated;

	return (
		<section
			className={`section chatmain ${isCorporateEvent ? "corporate-event-chatmain" : ""} ${
				showingWhatsAppBanner ? "banner-visible" : ""
			}`}
		>
			{showingWhatsAppBanner && (
				<div
					className={`whatsapp-banner ${isCorporateEvent ? "corporate-event-banner" : ""}`}
					onClick={() => {
						handleShowWhatsAppModal && handleShowWhatsAppModal();
					}}
				>
					<div className={"whatsapp-banner-title"}>
						<WhatsAppBannerIcon />
						<p className="whatsapp-banner-text">Tap here to chat on WhatsApp</p>
					</div>
					<CrossIcon
						cursor="pointer"
						onClick={(e) => {
							e.stopPropagation();
							handleShowWhatsAppBanner(false);
						}}
					/>
				</div>
			)}
			<Channel
				onSendChat={onSendChat}
				url={chanelUrl}
				onMessageUpdates={handleSendbirdMessageUpdates}
			/>
		</section>
	);
};

export default Chat;
